import Papa from "papaparse";

export function numberFormat(val: number | undefined) {
  if (typeof val === "number") {
    return val.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  } else {
    return val;
  }
}

export function formatCompactNumber(number: number | undefined) {
  if (typeof number === "number") {
    if (number < 1000) {
      return number;
    } else if (number >= 1000 && number < 1_000_000) {
      return (number / 1000).toFixed(1).replace(/\.0$/, "") + "K";
    } else if (number >= 1_000_000 && number < 1_000_000_000) {
      return (number / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
    } else if (number >= 1_000_000_000 && number < 1_000_000_000_000) {
      return (number / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B";
    } else if (number >= 1_000_000_000_000 && number < 1_000_000_000_000_000) {
      return (number / 1_000_000_000_000).toFixed(1).replace(/\.0$/, "") + "T";
    }
  } else {
    return number || "";
  }
}

export function getCsvContent<T>(
  file: File,
  keys: (keyof T)[],
): Promise<T[]> {
  return new Promise((resolve, reject) => {
    Papa.parse<string[]>(file, {
      skipEmptyLines: 'greedy',
      transform: (value) => value.trim(),
      complete(results) {
        try {
          const rows = results.data;

          if (rows.length <= 1) {
            reject(new Error("CSV file contains no data rows."));
            return;
          }

          const dataRows = rows.slice(1);

          const data = dataRows.map((row) => {
            const obj = {} as T;

            keys.forEach((key, index) => {
              obj[key] = (row[index] ?? "") as T[keyof T];
            });

            return obj;
          });

          resolve(data);
        } catch (error) {
          reject(error);
        }
      },

      error(error) {
        reject(error);
      },
    });
  });
}

export const emailPattern =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
